import axios from "axios";

export async function send_coze_image(
  token,
  bot_id,
  user_id,
  image_ids,
  onUpdate
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: true,
      additional_messages: [
        {
          content: JSON.stringify([
            { type: "text", text: "请分析这张图片" },
            ...image_ids.map((id) => {
              //判断id是地址还是文件id
              if (id.indexOf('http') > -1) {
                return {
                  type: "image",
                  file_url: id,
                }
              } 
              
              return {
                type: "image",
                file_id: id,
              }
            }),
          ]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;
  let typewriterTimer = null;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行
    // 处理每行数据

    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.delta"
    ) {
      //遍历lines，找到event:conversation.message.completed 删除他后面一元素
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].trim() === "event:conversation.message.completed") {
          lines.splice(i + 1, 1);
        }
      }
      for (const line of lines) {
        if (line.trim() === "") continue;

        // 移除 "data: " 前缀
        if (line.startsWith("data:")) {
          const jsonStr = line.slice(5);
          if (jsonStr.trim() === "[DONE]") {
            // 流结束
            clearTimeout(typewriterTimer);
            return fullText;
          }

          try {
            const json = JSON.parse(jsonStr);
            if (json.content) {
              fullText += json.content;

              // 启动打字机效果
              if (typewriterTimer === null) {
                typewriterEffect();
              }
            }
          } catch (error) {
            console.error("解析JSON错误:", error);
          }
        }
      }
    } else {
      continue;
    }
  }

  // 打字机效果函数
  function typewriterEffect() {
    if (currentIndex < fullText.length) {
      // 调用回调函数更新数据
      onUpdate(fullText.substring(0, currentIndex + 1));
      currentIndex++;

      // 根据剩余字数动态调整打字速度
      const remainingChars = fullText.length - currentIndex;
      // 定义最大和最小延迟时间（毫秒）
      const maxDelay = 20; // 最慢速度
      const minDelay = 5; // 最快速度
      // 计算当前延迟时间（剩余字数越多，延迟越长）
      const delay = Math.max(
        minDelay,
        maxDelay * (remainingChars / fullText.length)
      );

      // 设置打字机速度
      typewriterTimer = setTimeout(typewriterEffect, delay);
    } else {
      clearTimeout(typewriterTimer);
      typewriterTimer = null;
    }
  }

  return fullText;
}

export async function send_coze_audio_to_text(
  token,
  bot_id,
  user_id,
  audio_ids,
  onUpdate
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      workflow_id: "7589549030897254441",
      stream: true,
      parameters: {
        CONVERSATION_NAME: "Default",
        USER_INPUT: "转文字",
        audio_url: JSON.stringify({
          type: "file",
          file_id: audio_ids[0],
        }),
      },
      additional_messages: [
        {
          content: JSON.stringify([
            { type: "text", text: "请分析这音频转文字" },
            ...audio_ids.map((id) => {
              //判断id是地址还是文件id
              if (id.indexOf('http') > -1) {
                return {
                  type: "file",
                  file_url: id,
                }
              } 
              
              return {
                type: "file",
                file_id: id,
              }
            }),
          ]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;
  let typewriterTimer = null;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行
    // 处理每行数据
    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.delta"
    ) {
      //遍历lines，找到event:conversation.message.completed 删除他后面一元素
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].trim() === "event:conversation.message.completed") {
          lines.splice(i + 1, 1);
        }
      }
      for (const line of lines) {
        if (line.trim() === "") continue;

        // 移除 "data: " 前缀
        if (line.startsWith("data:")) {
          const jsonStr = line.slice(5);
          if (jsonStr.trim() === "[DONE]") {
            // 流结束
            clearTimeout(typewriterTimer);
            return fullText;
          }

          try {
            const json = JSON.parse(jsonStr);
            if (json.content) {
              fullText += json.content;
              // 启动打字机效果
              if (typewriterTimer === null) {
                typewriterEffect();
              }
            }
          } catch (error) {
            console.error("解析JSON错误:", error);
          }
        }
      }
    } else {
      continue;
    }
  }

  // 打字机效果函数
  function typewriterEffect() {
    if (currentIndex < fullText.length) {
      // 调用回调函数更新数据
      onUpdate(fullText.substring(0, currentIndex + 1));
      currentIndex++;

      // 根据剩余字数动态调整打字速度
      const remainingChars = fullText.length - currentIndex;
      // 定义最大和最小延迟时间（毫秒）
      const maxDelay = 20; // 最慢速度
      const minDelay = 5; // 最快速度
      // 计算当前延迟时间（剩余字数越多，延迟越长）
      const delay = Math.max(
        minDelay,
        maxDelay * (remainingChars / fullText.length)
      );

      // 设置打字机速度
      typewriterTimer = setTimeout(typewriterEffect, delay);
    } else {
      clearTimeout(typewriterTimer);
      typewriterTimer = null;
    }
  }

  return fullText;
}

export async function send_coze_audio_to_text2(
  token,
  bot_id,
  user_id,
  audio_ids,
  onUpdate
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: false,
      additional_messages: [
        {
          content: JSON.stringify([
            { type: "text", text: "请将这段音频转写成文字" },
            ...audio_ids.map((id) => ({
              type: "file",
              file_id: id,
            })),
          ]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let timer = "";
  let fullText = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    const lines = decoder.decode(value).split("\n");
    const data = JSON.parse(lines);

    if (data.data.status == "in_progress") {
      timer = setInterval(async () => {
        fullText = await parseCozeResponse(data);
        if (fullText) {
          onUpdate(fullText);
          clearInterval(timer);
        }
      }, 1000);

      setTimeout(() => {
        if (timer) {
          clearInterval(timer);
        }
      }, 15000);
    }
  }

  async function parseCozeResponse(data) {
    const res = await axios.get(`https://api.coze.cn/v3/chat/message/list`, {
      params: {
        conversation_id: data.data.conversation_id,
        chat_id: data.data.id,
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (res.data.data.status == "completed") {
      return res.data.data.messages[0].content;
    }
    return "";
  }

  return fullText;
}

export async function send_coze_audio_to_whiteboard(
  token,
  bot_id,
  user_id,
  text,
  onUpdate
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: true,
      additional_messages: [
        {
          content: JSON.stringify([
            { type: "text", text: "请根据这段文字润色" },
            { type: "text", text: text },
          ]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;
  let typewriterTimer = null;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行

    // 判断lines第一个元素是否是event:conversation.message.completed，如果是则停止输出
    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.delta"
    ) {
      for (const line of lines) {
        if (line.trim() === "") continue;

        // 移除 "data: " 前缀
        if (line.startsWith("data:")) {
          const jsonStr = line.slice(5);
          if (jsonStr.trim() === "[DONE]") {
            // 流结束
            clearTimeout(typewriterTimer);
            return fullText;
          }

          try {
            const json = JSON.parse(jsonStr);
            if (json.content) {
              fullText += json.content;

              // 启动打字机效果
              if (typewriterTimer === null) {
                typewriterEffect();
              }
            }
          } catch (error) {
            console.error("解析JSON错误:", error);
          }
        }
      }
    } else {
      continue;
    }
  }

  // 打字机效果函数
  function typewriterEffect() {
    if (currentIndex < fullText.length) {
      // 调用回调函数更新数据
      onUpdate(fullText.substring(0, currentIndex + 1));
      currentIndex++;

      // 根据剩余字数动态调整打字速度
      const remainingChars = fullText.length - currentIndex;
      // 定义最大和最小延迟时间（毫秒）
      const maxDelay = 20; // 最慢速度
      const minDelay = 5; // 最快速度
      // 计算当前延迟时间（剩余字数越多，延迟越长）
      const delay = Math.max(
        minDelay,
        maxDelay * (remainingChars / fullText.length)
      );

      // 设置打字机速度
      typewriterTimer = setTimeout(typewriterEffect, delay);
    } else {
      clearTimeout(typewriterTimer);
      typewriterTimer = null;
    }
  }

  return fullText;
}

export async function send_coze_to_whiteboard(
  token,
  bot_id,
  user_id,
  text,
  onUpdate,
  onEnd,
  school_id='',
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: true,
      "parameters": {
        "school_id":String(school_id) 
      },
      // school_id: school_id,
      additional_messages: [
        {
          content: JSON.stringify([{ type: "text", text: text }]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;
  let typewriterTimer = null;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    //结束
    if (done) {
      setTimeout(() => {
        clearTimeout(typewriterTimer);
        onEnd(fullText);
      }, 1500);
      break;
    } 
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行
    // 判断lines第一个元素是否是event:conversation.message.completed，如果是则停止输出
    // if (lines.length > 0 && lines[0].trim() === 'event:conversation.message.completed') {
    //     clearTimeout(typewriterTimer);
    //     // 最后调用一次onUpdate确保内容完整
    //     if (fullText) {
    //         onUpdate(fullText);
    //     }
    //     return fullText;
    // }
    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.delta"
    ) {
      //遍历lines，找到event:conversation.message.completed 删除他后面一元素
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].trim() === "event:conversation.message.completed") {
          lines.splice(i + 1, 1);
        }
      }
      for (const line of lines) {
        if (line.trim() === "") continue;

        // 移除 "data: " 前缀
        if (line.startsWith("data:")) {
          const jsonStr = line.slice(5);
          if (jsonStr.trim() === "[DONE]") {
            // 流结束
            clearTimeout(typewriterTimer);
            onEnd(fullText);
            return fullText;
          }

          try {
            const json = JSON.parse(jsonStr);
            if (json.content) {
              fullText += json.content;

              // 启动打字机效果
              if (typewriterTimer === null) {
                typewriterEffect();
              }
            }
          } catch (error) {
            console.error("解析JSON错误:", error);
          }
        }
      }
    } else if (lines.length > 0 && lines[0].trim() === "done") {
      //结束
      clearTimeout(typewriterTimer);
      onEnd(fullText);
      return fullText;
    } else {
      continue;
    }
  }

  // 打字机效果函数
  function typewriterEffect() {
    if (currentIndex < fullText.length) {
      // 调用回调函数更新数据
      onUpdate(fullText.substring(0, currentIndex + 1));
      currentIndex++;

      // 根据剩余字数动态调整打字速度
      const remainingChars = fullText.length - currentIndex;
      // 定义最大和最小延迟时间（毫秒）
      const maxDelay = 16; // 最慢速度
      const minDelay = 2; // 最快速度
      // 计算当前延迟时间（剩余字数越多，延迟越长）
      const delay = Math.max(
        minDelay,
        maxDelay * (remainingChars / fullText.length)
      );

      // 设置打字机速度
      typewriterTimer = setTimeout(typewriterEffect, delay);
    } else {
      clearTimeout(typewriterTimer);
      typewriterTimer = null;
    }
  }

  return fullText;
}

export async function send_coze_field(token, bot_id, user_id, text, school_id, onUpdate,onEnd) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      school_id: String(school_id),
      stream: true,
      additional_messages: [
        {
          content: JSON.stringify([{ type: "text", text: text }]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行

    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.delta"
    ) {
      //遍历lines，找到event:conversation.message.completed 删除他后面一元素
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].trim() === "event:conversation.message.completed") {
          lines.splice(i + 1, 1);
        }
      }
      for (const line of lines) {
        if (line.trim() === "") continue;

        // 移除 "data: " 前缀
        if (line.startsWith("data:")) {
          const jsonStr = line.slice(5);
          if (jsonStr.trim() === "[DONE]") {
            // 流结束
            clearTimeout(typewriterTimer);
            onEnd(fullText);
            return fullText;
          }

          try {
            const json = JSON.parse(jsonStr);
            if (json.content) {
              fullText += json.content;

              // 启动打字机效果
              if (typewriterTimer === null) {
                typewriterEffect();
              }
            }
          } catch (error) {
            console.error("解析JSON错误:", error);
          }
        }
      }
    } else {
      continue;
    }
  }
  return fullText;
}

/**
 * 发送视频帧图片分析请求
 * @param {string} token - Coze API令牌
 * @param {string} bot_id - 机器人ID
 * @param {string|number} user_id - 用户ID
 * @param {Array} image_ids - 图片文件ID数组
 * @param {Function} onUpdate - 结果更新回调函数
 * @returns {Promise<string>} - 完整的分析结果
 */
export async function send_coze_video_frames(
  token,
  bot_id,
  user_id,
  image_ids,
  onUpdate
) {
  // 使用 fetch API 发送请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: true,
      additional_messages: [
        {
          content: JSON.stringify([
            { type: "text", text: "请分析这些视频帧，总结视频内容并生成白描" },
            ...image_ids.map((id) => {
              //判断id是地址还是文件id
              if (id.indexOf('http') > -1) {
                return {
                  type: "image",
                  file_url: id,
                }
              } 

              return {
                type: "image",
                file_id: id,
              }
            }),
          ]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // 获取响应流
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  let fullText = "";
  let currentIndex = 0;
  let typewriterTimer = null;

  // 处理流数据
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    // 解码数据
    buffer += decoder.decode(value, { stream: true });
    // 按行分割数据
    let lines = buffer.split("\n");
    buffer = lines.pop(); // 保留不完整的最后一行
    // 判断lines第一个元素是否是event:conversation.message.completed，如果是则停止输出
    if (
      lines.length > 0 &&
      lines[0].trim() === "event:conversation.message.completed"
    ) {
      clearTimeout(typewriterTimer);
      // 最后调用一次onUpdate确保内容完整
      if (fullText) {
        onUpdate(fullText);
      }
      return fullText;
    }

    for (const line of lines) {
      if (line.trim() === "") continue;

      // 移除 "data: " 前缀
      if (line.startsWith("data:")) {
        const jsonStr = line.slice(5);
        if (jsonStr.trim() === "[DONE]") {
          // 流结束
          clearTimeout(typewriterTimer);
          return fullText;
        }

        try {
          const json = JSON.parse(jsonStr);
          if (json.content) {
            fullText += json.content;

            // 启动打字机效果
            if (typewriterTimer === null) {
              typewriterEffect();
            }
          }
        } catch (error) {
          console.error("解析JSON错误:", error);
        }
      }
    }
  }

  // 打字机效果函数
  function typewriterEffect() {
    if (currentIndex < fullText.length) {
      // 调用回调函数更新数据
      onUpdate(fullText.substring(0, currentIndex + 1));
      currentIndex++;

      // 根据剩余字数动态调整打字速度
      const remainingChars = fullText.length - currentIndex;
      // 定义最大和最小延迟时间（毫秒）
      const maxDelay = 20; // 最慢速度
      const minDelay = 5; // 最快速度
      // 计算当前延迟时间（剩余字数越多，延迟越长）
      const delay = Math.max(
        minDelay,
        maxDelay * (remainingChars / fullText.length)
      );

      // 设置打字机速度
      typewriterTimer = setTimeout(typewriterEffect, delay);
    } else {
      clearTimeout(typewriterTimer);
      typewriterTimer = null;
    }
  }

  return fullText;
}

export async function send_coze_text_non_stream(
  token,
  bot_id,
  user_id,
  text,
  onSuccess
) {
  // 使用 fetch API 发送非流式请求
  const response = await fetch("https://api.coze.cn/v3/chat", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      bot_id: bot_id,
      user_id: String(user_id),
      stream: false,
      additional_messages: [
        {
          content: JSON.stringify([{ type: "text", text: text }]),
          content_type: "object_string",
          role: "user",
        },
      ],
    }),
  });

  // 检查响应状态
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  let fullText = "";
  let pollingInterval = null;
  // 否则开始轮询
  pollingInterval = setInterval(async () => {
    await parseCozeResponse(data.data, token);
  }, 2000); // 每秒轮询一次

  async function parseCozeResponse(responseData, authToken) {
    const res = await axios.get(`https://api.coze.cn/v3/chat/retrieve`, {
      params: {
        conversation_id: responseData.conversation_id,
        chat_id: responseData.id,
      },
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });
    if (res.data.data && res.data.data.status === "completed") {
      // 提取所有助手消息的内容
      const res2 = await axios.get(`https://api.coze.cn/v3/chat/message/list`, {
        params: {
          conversation_id: responseData.conversation_id,
          chat_id: responseData.id,
        },
        headers: {
          Authorization: "Bearer " + authToken,
        },
      });

      if (res2.data.data) {
        onSuccess(res2.data.data);
        clearInterval(pollingInterval);
        return "";
      }
    }
  }

  return fullText;
}
